module.exports = __webpack_public_path__ + "img/0919_04.b108c309.jpg";